import { createStore } from "vuex";
import order from "./modules/order";
import voucher from "./modules/voucher";
import buyer from "./modules/buyer";
import seller from "./modules/seller";
import product from "./modules/product";
import publicHoliday from "./modules/publicHoliday";
import reports from "./modules/reports";
import withdraw from "./modules/withdraw";
import order_fee from "./modules/order_fee";
import marketing from "./modules/marketing";
import refunds from "./modules/refunds";
import banner from "./modules/banner";
import contentText from "./modules/contentText";
import services from "@/services";

export default createStore({
  state: {
    token: localStorage.getItem("access_token") || null,
    globalSettings: {},
    loadingGlobal: false,
    loadingTable: false,
    isGoogleInit: false,
    googleUser: {}
  },
  getters: {
    loggedIn(state) {
      return state.token !== null;
    },
  },
  mutations: {
    retrieveToken(state, token) {
      state.token = token;
    },
    dicardToken(state, token) {
      state.token = token;
    },
    storeGlobalSettings(state, data) {
      state.globalSettings = data;
    },
    storeUpdateLocalGlobalSettings(state, data) {
      const obj = { ...state.globalSettings };
      Object.keys(data).forEach((key) => {
        obj[key] = { ...obj[key], ...data[key] }
      });
      state.globalSettings = obj;
    },
    storeLoadingGlobal(state, bool) {
      state.loadingGlobal = bool;
    },
    storeLoadingTable(state, bool) {
      state.loadingTable = bool;
    },
    storeIsGoogleInit(state, bool) {
      state.isGoogleInit = bool;
    },
    storeGoogleUser(state, data) {
      state.googleUser = data;
    },
  },
  actions: {
    setIsGoogleInit({ commit }, bool) {
      commit("storeIsGoogleInit", bool);
    },
    setGoogleUser({ commit }, data) {
      commit("storeGoogleUser", data);
    },
    setLoadingGlobal({ commit }, bool) {
      commit("storeLoadingGlobal", bool);
    },
    setLoadingTable({ commit }, bool) {
      commit("storeLoadingTable", bool);
    },
    destroyToken() {
      localStorage.access_token = "";
    },
    retrieveToken({ commit }, payload) {
      return new Promise((resolve, reject) => {
        services
          .post("login", payload)
          .then((response) => {
            localStorage.setItem("access_token", response.data.data.item.token);
            commit("retrieveToken", response.data.data.item.token);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    googleLogin({ commit }, payload) {
      /**
       * payload : {
       *    "client_id": "",
       *    "jwt_token": ""
       * }
       */
      return new Promise((resolve, reject) => {
        services
          .post(`${process.env.VUE_APP_API_MANAGER}/api/v1/googlelogin`, payload)
          .then((response) => {
            localStorage.setItem("access_token", response.data.data.token);
            localStorage.setItem("device_id", response.data.data.device_info?.id);
            commit("retrieveToken", response.data.data.token);
            resolve(response.data.data.token);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    logout({ commit }, payload) {
      return new Promise((resolve, reject) => {
        services
          .post("logout", payload)
          .then(() => {
            localStorage.setItem("access_token", "");
            commit("dicardToken", "");
            resolve(true);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    googleLogout({ commit }, payload) {
      return new Promise((resolve, reject) => {
        services
          .post(`${process.env.VUE_APP_API_MANAGER}/api/v1/googlelogout`, payload)
          .then((response) => {
            localStorage.setItem("access_token", "");
            commit("dicardToken", "");
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateLocalGlobalSettings({ commit }, data) {
      commit("storeUpdateLocalGlobalSettings", data);
    },
    getGlobalSettings({ commit }) {
      return new Promise((resolve, reject) => {
        services
          .get("global-setting", { type: "" })
          .then((response) => {
            commit("storeGlobalSettings", response.data.data.items);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  modules: {
    voucher,
    order,
    buyer,
    seller,
    product,
    publicHoliday,
    reports,
    marketing,
    withdraw,
    order_fee,
    refunds,
    banner,
    contentText
  },
});
